import { supabase } from "@/integrations/supabase/client";

export async function claimAccountSession(): Promise<"owned" | "blocked" | "unavailable"> {
  try {
    const { data, error } = await supabase.rpc("claim_account_session");
    if (error) {
      const message = typeof error === "object" && error !== null && "message" in error ? String(error.message) : "";
      return message.includes("ACCOUNT_SESSION_IN_USE") ? "blocked" : "unavailable";
    }
    return data === true ? "owned" : "blocked";
  } catch { return "unavailable"; }
}

export async function releaseAccountSession(): Promise<void> {
  // If offline, the Auth session remains authoritative; never claim release succeeded.
  await supabase.rpc("release_account_session");
}